import api from './api';

/**
 * Map API expense → Frontend expense (public transparency view)
 */
function mapTransparencyExpense(e) {
  return {
    id: e.id,
    description: e.description,
    amount: parseFloat(e.amount),
    expenseDate: e.expense_date,
    category: e.category?.name || (typeof e.category === 'string' ? e.category : '') || '',
    categoryColor: e.category?.color,
    notes: e.notes,
    createdAt: e.created_at,
  };
}

/**
 * Get public transparency expenses (no auth required)
 * @param {Object} params - Query parameters
 * @returns {Promise} { data, total, page, pageSize }
 */
export const getTransparencyExpenses = async (params = {}) => {
  try {
    const mapped = {};
    if (params.page) mapped.page = params.page;
    if (params.pageSize) mapped.per_page = params.pageSize;
    if (params.category_id) mapped.category_id = params.category_id;
    if (params.dateFrom) mapped.date_from = params.dateFrom;
    if (params.dateTo) mapped.date_to = params.dateTo;

    const response = await api.get('/transparency/expenses', { params: mapped });
    const { data, meta } = response.data;

    return {
      data: data.map(mapTransparencyExpense),
      total: meta?.total || data.length,
      page: meta?.current_page || 1,
      pageSize: meta?.per_page || 15,
    };
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao buscar despesas do portal.');
  }
};

/**
 * Get public categories list (no auth required)
 * @returns {Promise} Array of categories
 */
export const getTransparencyCategories = async () => {
  try {
    const response = await api.get('/transparency/categories');
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao buscar categorias.');
  }
};

/**
 * Get public transparency summary (no auth required)
 * @returns {Promise} Summary data
 */
export const getTransparencySummary = async () => {
  try {
    const response = await api.get('/transparency/summary');
    return response.data.data || response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao buscar resumo do portal.');
  }
};
